import { AccessibilityInfo, Platform, UIManager } from 'react-native';
var FUNC_ERROR_TEXT = 'Expected a function';
export var checkIsPlatform = platform => {
  return Platform.OS === platform;
};
export var getTestId = (testID, postfix) => {
  if (!testID) return {};
  var _testID = testID;
  if (postfix) _testID = testID + "_" + postfix;
  var data = {
    testID: _testID
  };
  return data;
};
export var getCurrentEventControlState = (event, controlState) => {
  if (controlState && controlState != 'none') return controlState;
  if (event === null || event === void 0 ? void 0 : event.pressed) {
    return 'pressed';
  } else if (event === null || event === void 0 ? void 0 : event.hovered) {
    return 'hover';
  } else if (event === null || event === void 0 ? void 0 : event.disabled) {
    return 'disabled';
  } else {
    return 'none';
  }
};
export var isLastItem = (array, index) => {
  return (array === null || array === void 0 ? void 0 : array.length) - 1 == index;
};
export var isFirstItem = index => {
  return index === 0;
};
export var fitContentWidth = () => {
  return Platform.OS === 'web' ? {
    width: 'fit-content'
  } : {
    alignSelf: 'flex-start'
  };
};
export var announceAccessibility = textsToAnnounce => {
  var concatenatedText = textsToAnnounce.filter(Boolean).join('. ');
  AccessibilityInfo.announceForAccessibility(concatenatedText);
};
export var isValidObject = data => {
  return data && typeof data === 'object' && Object.keys(data).length > 0;
};
export var getKebabCase = str => {
  var _a, _b;
  return (_b = (_a = str === null || str === void 0 ? void 0 : str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+|[A-Z]|[0-9]+/g)) === null || _a === void 0 ? void 0 : _a.join('-')) === null || _b === void 0 ? void 0 : _b.toLowerCase();
};
if (checkIsPlatform('android')) {
  if (UIManager.setLayoutAnimationEnabledExperimental) {
    UIManager.setLayoutAnimationEnabledExperimental(true);
  }
}
export function debounce(func, wait, options) {
  var lastArgs,
    lastThis,
    maxWait,
    result,
    timerId,
    lastCallTime,
    lastInvokeTime = 0,
    leading = false,
    maxing = false,
    trailing = true;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Number(wait) || 0;
  if (isValidObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? Math.max(Number(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs;
    var thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - (lastCallTime || 0),
      timeSinceLastInvoke = time - lastInvokeTime,
      result = wait - timeSinceLastCall;
    return maxing ? Math.min(result, maxWait - timeSinceLastInvoke) : result;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - (lastCallTime || 0),
      timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = Date.now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = undefined;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }
  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }
  function flush() {
    return timerId === undefined ? result : trailingEdge(Date.now());
  }
  var debounced = function debounced() {
    var time = Date.now();
    var isInvoking = shouldInvoke(time);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    lastArgs = args;
    lastThis = undefined;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  };
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}